import { gql } from "@apollo/client";

export const TEST_TWILLO = gql`
mutation SendTextMessage($createTextInput: CreateTextInput!) {
  sendTextMessage(createTextInput: $createTextInput)
}
`


export const SAVE_TWILLO = gql`
mutation CreateText($createTextInput: CreateTextInput!) {
  createText(createTextInput: $createTextInput) {
    message
  }
}
`

export const REMOVE_TWILLIO = gql`
mutation{
  deleteTextService
}
`